module.exports = __webpack_public_path__ + "img/wiki-screenshot-2x.830b799c.png";